module.exports = __webpack_public_path__ + "img/fourday_ps_12.01fa1442.jpg";